import React from 'react';

const About = () => {
  return (
    <div className="w-full flex flex-col items-center bg-secondary-100 mt-2 pb-20">
      <div className="w-4/5 bg-white rounded mt-14 pt-10 border border-gray-300 pb-20">
        <section className="flex flex-col items-center">
          <h2 className="header">A propos TZ Lab</h2>
          <div className="flex flex-col items-center md:flex-row md:items-start mt-2 md:mt-16 w-4/5">
            <p className="text-center md:text-left mt-10 md:mr-10">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorum odit libero aliquam ex cum dolore saepe
              cupiditate. Necessitatibus quaerat, corrupti fuga facilis ad repellat, veritatis, suscipit laudantium
              reprehenderit est pariatur.</p>
            <img src="./assets/images/logo.png" alt="logo" className="w-40 mt-10 md:mt-0" />
          </div>
        </section>
        <section className="flex flex-col items-center mt-24">
          <h2 className="header">Laissez nous un commentaire</h2>
          <form action="https://submit-form.com/RNwKMN2U" method="POST" className="w-full px-4 md:w-2/5 flex flex-col mt-10">
            <input
              type="hidden"
              name="_redirect"
              value="http://localhost:3000/merci"
            />
            <input type="text" name="nom" placeholder="Votre nom" required className="input" />
            <input type="email" name="email" placeholder="Votre e-mail" required className="input" />
            <textarea name="commentaire" cols="30" rows="5" placeholder="Votre commentaire..." required className="input resize-none" />
            <input type="submit" value="Envoyer" className="submitBtn" />
          </form>
        </section>
      </div>
    </div>
  );
};

export default About;
